<i18n>
{
  "en": {
    "email": "Email",
    "existingConnectionWithEmail": "You already have a connexion with this email",
    "name": "Name",
    "noConnection": "You don't have any connection, start by adding one!"
  },
  "fr": {
    "existingConnectionWithEmail": "You already have a connexion with this email",
    "email": "Email",
    "name": "Name",
    "noConnection": "You don't have any connection, start by adding one!"
  }
}
</i18n>
<template>
  <v-container>
    <v-row
    no-gutters>
      <v-col
        md="6"
        offset-md="3"
      >
        <messages-list :messages="messages"/>
        <v-btn color="primary" @click="connectGoogle">
          <v-icon left>add</v-icon>
          Connect Google
        </v-btn>
        <v-data-table
          class="elevation-1 mt-5"
          :headers="headers"
          :items="connections"
          :no-data-text="$t('noConnection')"
          hide-default-footer
          :loading="loading"
          >
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import messagesList from '@/components/messages-list'

export default {
  name: 'connectionsPage',
  components: {
    messagesList
  },
  data () {
    return {
      headers: [
        {
          align: 'left',
          value: 'decryptedGoogleName',
          text: this.$t('name'),
          sortable: true
        },
        {
          align: 'left',
          value: 'decryptedGoogleEmail',
          text: this.$t('email'),
          sortable: true
        }
      ],
      loading: false,
      messages: []
    }
  },
  computed: {
    connections () {
      return this.$store.getters.getConnections
    },
    organization () {
      return this.$store.getters.getOrganization
    },
    organizationId () {
      if (this.organization) {
        return this.organization.id
      }
      return null
    }
  },
  async created () {
    this.loading = true
    await this.$store.dispatch('getOrganizationConnections')
    this.loading = false
  },
  methods: {
    async connectGoogle () {
      try {
        this.messages = []
        const authCode = await this.$gAuth.getAuthCode()
        await this.$store.dispatch('createOrganizationConnection', {
          code: authCode
        })
      } catch (err) {
        this.messages = err.response.data.errors.map(err => this.$t(err.msg))
      }
    }
  }
}
</script>

<style>

</style>
